export default __webpack_public_path__ + "static/media/loader-black.21a707f5.svg";